import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=55b7b41e&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7b41e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b7b41e')) {
      api.createRecord('55b7b41e', component.options)
    } else {
      api.reload('55b7b41e', component.options)
    }
    module.hot.accept("./QuestionList.vue?vue&type=template&id=55b7b41e&scoped=true", function () {
      api.rerender('55b7b41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/questionnaire/question/QuestionList.vue"
export default component.exports